import { Box, Stack, Typography } from '@mui/material'
import React from 'react'

import { CodeBlock } from 'components/common/CodeBlock'
import { TutorialStep } from 'components/common/TutorialStep'
import { useObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { useTranslation } from 'hooks/use-translation'

export const PermissionPolicy: React.FC<{ badeCount: number }> = ({
  badeCount
}) => {
  const { trans } = useTranslation()
  const { awsIAMRoleMetadata } = useObservabilityToolAuthenticationContext()

  return (
    <TutorialStep
      badgeNumber={badeCount}
      title={trans(
        'status_checks.authentication.aws.iam_role.manual_method.step_2.title'
      )}
    >
      <Box ml={1} mt={1}>
        <Stack spacing={1}>
          <Typography>
            Use this permission policy for your service account. This policy
            explains the permissions needed for your service account
          </Typography>
          <CodeBlock
            code={awsIAMRoleMetadata?.permissionPolicy}
            includeLineNumbers={false}
            isCopyEnabled={true}
          />
        </Stack>
      </Box>
    </TutorialStep>
  )
}
